import React from 'react'
import OrderReports from './OrderReports/OrderReports'
import InvoiceReports from './InvoiceReports/InvoiceReports'
import Tab from '../../components/UI/OrderTabbedPanel/TabbedPanel'
import { Grid } from '@material-ui/core'

const Reports = (props) => {
    const tabs = [
        {
            index: 0,
            label: "گزارش تراکنش ها",
            value: <OrderReports />
        },
        {
            index: 1,
            label: "گزارش صورت حساب ها",
            value: <InvoiceReports />
        }
    ]
    return (
        <div className='row justify-content-center'>
            <Grid lg={11} xs={11}>
                <Tab tabs={tabs} />
            </Grid>
        </div>
    )
}

export default Reports